export default {
  async: false,
  background: {
    color: '#F8F7F5',
  },
  connecting: {
    connector: {
      name: 'jumpover',
      args: {
        type: 'gap',
        radius: 10,
      },
    },
    router: {
      name: 'orth',
      args: {
        excludeTerminals: ['source', 'target'],
        startDirections: ['bottom'],
        endDirections: ['top'],
        padding: 10,
      },
    },
  },
  grid: {
    size: 10,
    visible: true,
  },
  interacting: {
    nodeMovable: false,
    edgeMovable: false,
  },
  mousewheel: {
    enabled: true,
    zoomAtMousePosition: true,
    modifiers: ['ctrl', 'meta'],
    factor: 1.1,
  },
  preventDefaultContextMenu: process.env.NODE_ENV !== 'development',
  scaling: {
    min: 0.07,
    max: 4,
  },
};
